module.exports = __webpack_public_path__ + "static/media/bar2.c46921f9.jpg";